<template>
  <NuxtLink
    class="comparison-livestorm-card"
    :to="to"
  >
    <span class="livestorm">
      <UiComponentImage
        :key="logoSize"
        :alt="livestormLogo.alt"
        :expected-size="logoSize"
        :height="livestormLogo.height"
        :source="livestormLogo.url"
        :width="livestormLogo.width"
      />
      <strong>Livestorm</strong>
    </span>
    <span class="vs">vs</span>
    <span class="alternative">
      <strong :style="{ color: compareSoftware.color }">{{
        compareSoftware.name
      }}</strong>
    </span>
  </NuxtLink>
</template>

<script setup>
// Composables
const localePath = useLocalePath()
const { width: screenWidth } = useScreenSize()

// Props
const props = defineProps({
  compareSoftware: {
    required: true,
    type: Object,
  },
  livestormLogo: {
    required: true,
    type: Object,
  },
  slug: {
    required: true,
    type: String,
  },
})

// Computed Properties
const logoSize = computed(() => {
  return screenWidth.value < 768 ? 21 : 26
})

const title = computed(() => {
  return `Livestorm vs ${props.compareSoftware.name}`
})

const to = computed(() => {
  return localePath({
    name: 'webinar-software-comparison-slug',
    params: {
      slug: props.slug,
    },
  })
})
</script>

<style lang="postcss" scoped>
.comparison-livestorm-card {
  @apply relative flex flex-col bg-white border-2 border-grey-blue-200 rounded-[24px] overflow-hidden transition-shadow ease-in-out duration-300;
  height: 158px;

  @screen md {
    height: 200px;
  }

  &:hover {
    @apply shadow-xl;
  }

  .livestorm {
    @apply flex items-center justify-center bg-blizzard-100;
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
    height: 78px;

    @screen md {
      height: 99px;
    }

    picture {
      @apply rounded-none;
    }

    strong {
      @apply ml-2 font-bold text-xl text-winter-green-900 text-center leading-7;
      margin-left: 10px;

      @screen md {
        @apply text-2xl leading-8;
        margin-left: 10px;
      }
    }
  }

  .vs {
    @apply absolute flex items-center justify-center bg-white font-bold text-sm text-grey-blue-400 border-2 border-grey-blue-200 rounded-xs;
    top: 50%;
    left: 50%;
    line-height: 18.2px;
    width: 28px;
    height: 28px;
    margin-top: -14px;
    margin-left: -14px;
  }

  .alternative {
    @apply flex flex-grow justify-center items-center;

    strong {
      @apply font-medium text-center text-origin leading-7;
    }
  }
}
</style>
